import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// Utility function for API requests
const apiRequest = async (apiFn, api, data, errorMessage) => {
  try {
    const response = await apiFn(api, data);
    if (response?.success) {
      return response?.data;
    } else {
      throw new Error(response?.message || errorMessage);
    }
  } catch (error) {
    throw new Error(error.message || errorMessage);
  }
};

export const doctorReviewPost = createAsyncThunk(
  "website/doctor",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(API.DOCTOR_RATING, data);
      if (response?.success) {
        return response;
      }

      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AvgDoctorRating = createAsyncThunk(
  "get-doctor-rating",
  async ({ doctor_id }, { rejectWithValue }) => {
    try {
      const termsconditionsData = await GET(
        `${API.AVG_DOCTOR_RATING}/${doctor_id}`,
      );
      return termsconditionsData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const allDoctorRating = createAsyncThunk(
  "al-doctor-rating",
  async ({ doctor_id, page }, { rejectWithValue }) => {
    try {
      const termsconditionsData = await GET(
        `${API.DOCTOR_RATING}/${doctor_id}?page=${page || 1}`,
      );
      return termsconditionsData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Helper function to handle common async state transitions
const handleAsyncState = (state, action, isSignin = false) => {
  switch (action.type) {
    case "pending":
      state.status = "loading";
      break;
    case "fulfilled":
      state.status = "succeeded";
      if (isSignin) {
        state.token = action.payload;
        state.is_signin = true;
      }
      break;
    case "rejected":
      state.status = "failed";
      state.error = action.payload;
      if (isSignin) state.is_signin = false;
      break;
    default:
      return state;
  }
};

// Create the slice
const careerformSlice = createSlice({
  name: "doctorRating",
  initialState: {
    token: "",
    name: "",
    avg_rating: "",
    all_rating: "",
    error: null,
    status: "idle",
    is_signin: false,
  },
  reducers: {
    setIsSignedOut: (state) => {
      state.is_signin = false;
      state.token = "";
      state.name = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doctorReviewPost.pending, (state) =>
        handleAsyncState(state, { type: "pending" }),
      )
      .addCase(doctorReviewPost.fulfilled, (state, action) =>
        handleAsyncState(state, { type: "fulfilled", payload: action.payload }),
      )
      .addCase(doctorReviewPost.rejected, (state, action) =>
        handleAsyncState(state, { type: "rejected", payload: action.payload }),
      )

      .addCase(AvgDoctorRating.pending, (state) => {
        state.status = "loading";
      })
      .addCase(AvgDoctorRating.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.avg_rating = action.payload?.data || [];
      })
      .addCase(AvgDoctorRating.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(allDoctorRating.pending, (state) => {
        state.status = "loading";
      })
      .addCase(allDoctorRating.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.all_rating = action.payload?.data || [];
      })
      .addCase(allDoctorRating.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { setIsSignedOut } = careerformSlice.actions;

export default careerformSlice.reducer;
